import PropTypes from "prop-types";
import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { Button, Col, Image, Row } from "react-bootstrap";
import { AngleLeftIcon, AngleRightIcon } from "../data/iconImage";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "moment/locale/th";

moment.locale("th");
const localizer = momentLocalizer(moment);

const CustomToolbar = ({ date, onNavigate }) => {

  return (
    <Row className="mb-3 justify-content-between">
      <Row as={Col} className="align-items-center">
        <Button
          as={Col}
          variant="outline-success"
          className="w-auto col-1 border-0 align-items-center d-flex"
          onClick={() => onNavigate("PREV")}
        >
          <Image src={AngleLeftIcon} alt="Prev Icon" />
        </Button>

        <Col sm={2} className="w-auto fs-4 text-center">
          {moment(date).format("MMMM YYYY")}
        </Col>

        <Button
          as={Col}
          variant="outline-success"
          className="w-auto col-1 border-0 align-items-center d-flex"
          onClick={() => onNavigate("NEXT")}
        >
          <Image src={AngleRightIcon} alt="Next Icon" />
        </Button>
      </Row>

      <div className="w-auto h-4 bg-success m-2 d-flex"
      />
      มีงาน
      <div className="w-auto h-4 bg-light m-2 d-flex align-items-center"
      />
      ไม่มีงาน

    </Row>
  );
};

const CalendarTeamComponent = ({ events, selectDate, setSelectDate, onRangeChange }) => {
  const customFormats = {
    dateFormat: (date, culture, localizer) =>
      localizer.format(date, "D", culture),
    weekdayFormat: (date, culture, localizer) =>
      localizer.format(date, "dd", culture),
    dayFormat: (date, culture, localizer) =>
      localizer.format(date, "Do dd", culture),
    timeGutterFormat: (date, culture, localizer) =>
      localizer.format(date, "HH:mm", culture)
  };

  return (
    <Calendar
      defaultView="month"
      className="mx-auto"
      localizer={localizer}
      formats={customFormats}
      views={["month"]}
      // events={events}
      // eventPropGetter={eventStyleGetter}
      style={{ width: "65vw", maxWidth: "100%", height: "85vh" }}
      dayPropGetter={(date) => {
        // const show =(moment(date).month() == moment(new Date()).month())
        const select = selectDate == moment(date).format("DD/MM/YYYY")
        return { style: { backgroundColor: select ? "#f1f5f9" : "#fff" } }
      }}
      components={{
        toolbar: CustomToolbar,
        day: {
          header: ({ date, label, localizer }) =>
            localizer.format(date, "Do dddd", label)
        },
        month: {
          dateHeader: ({ date, label }) => {
            let highlight = events.find(event => (moment(event.date).format("DD/MM/YYYY") == (moment(date).format("DD/MM/YYYY"))))
            const isSelect = selectDate == moment(date).format("DD/MM/YYYY")
            return (
              <div style={{
                // background: selectDate == moment(date).format("DD/MM/YYYY") ? "#B2D137" : highlight && "rgba(178,209,55,0.4)",
                background: isSelect ? (!highlight ? "white": "#B2D137") : highlight && "#B2D137",
                outline: moment(date).format("DD/MM/YYYY") == moment().format("DD/MM/YYYY") ? "3px solid rgba(178,209,55,0.4)"
                : isSelect && "#F8F9FA 3px solid",
                width: "fit-content", minWidth: "1.75em", minHeight: "1.75em",
                padding: "2px 5px", margin: "auto", borderRadius: "50%",
                textAlign: "center", cursor: "pointer",
              }}
                onClick={() => setSelectDate(moment(date).format("DD/MM/YYYY"))}>
                {label}
              </div>
            )
          }
        }
      }}
      onRangeChange={onRangeChange}
    />
  );
};

CustomToolbar.propTypes = {
  date: PropTypes.object,
  views: PropTypes.array,
  onView: PropTypes.func,
  onNavigate: PropTypes.func
};

CalendarTeamComponent.propTypes = {
  events: PropTypes.array,
  selectDate: PropTypes.string,
  setSelectDate: PropTypes.func,
  onRangeChange: PropTypes.func
};

export default CalendarTeamComponent;
